module.exports = __webpack_public_path__ + "static/media/isa3.d14236a0.png";